// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__28_3l","messages":"Chat_messages__29AFF","dateDivider":"Chat_dateDivider__3h4IY"};